import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ModalAddTradeAgreementComponent } from '../modal-add-trade-agreement/modal-add-trade-agreement.component';
import { ModalMessageComponent } from '../modal-message/modal-message.component';

@Component({
  selector: 'app-modal-view-trade-agreement',
  templateUrl: './modal-view-trade-agreement.component.html',
  styleUrls: ['./modal-view-trade-agreement.component.scss']
})
export class ModalViewTradeAgreementComponent implements OnInit {

  organizationForm: FormGroup = new FormGroup({
    organization_id: new FormControl('', Validators.required),
    charge_frequency: new FormControl('', Validators.required),
    trial_end: new FormControl('', Validators.required),
    organization_email: new FormControl('---'),
    organization_label: new FormControl('---'),
    organization_phone: new FormControl('---'),
    organization_name_contact: new FormControl('---'),
    organization_city: new FormControl('---'),
    organization_zone: new FormControl('---'),
  });

  organizations: any = [];
  productsServices: any = []
  dataSource: any = [];
  charges: any = this.uService.charges;

  displayedColumns: any = [
    {variable: 'rowNumber', displayedName: 'N.'},
    {variable: 'product_name', displayedName: 'Producto'},
    // {variable: 'badge', displayedName: 'Divisa'},
    {variable: 'trial_price', displayedName: 'Precio prueba'},
    {variable: 'base_price', displayedName: 'Precio base'},
    {variable: 'product_price', displayedName: 'Precio'},
    {variable: 'product_line_name', displayedName: 'Linea de producto'},
    {variable: 'trial_start', displayedName: 'Fecha inicio'},
    {variable: 'trial_end_cap', displayedName: 'Fecha fin'},
    // {variable: 'options-prod-serv', displayedName: 'Acciones'},
  ];

  updateData(data: any){
    this.dataSource = [...data];
  }

  public addtradeAgreement(){
    const dialogRef = this.dialog.open(ModalAddTradeAgreementComponent, {
      // width: '550px',
      disableClose: true,
      data:  this.dataSource,
      // panelClass: 'content_modal'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != null) {
        this.productsServices.push(result);
        this.dataSource = [...this.productsServices];
      }
    });
  }

  public sendApporval(){
    var id = this.organizationForm.get('organization_id').value;

    if( this.organizationForm.valid ){
      const dialogRef = this.dialog.open(ModalMessageComponent, {
        // width: '550px',
        disableClose: true,
        panelClass: 'content-fit'
        // data: {  },
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.createComertialAgreement();
        }
      });
    }else{
      this.uService.validateForm(this.organizationForm);
    }

  }

  createComertialAgreement(){
    var id : string = this.organizationForm.get('organization_id').value;
    var charge_frequency : string = this.organizationForm.get('charge_frequency').value;
    var trial_end : string = this.organizationForm.get('trial_end').value;
    // var arraytoReturn = this.uService.filterSelectedFields(this.dataSource, ['product_price', 'trial_price'])
    var arrayToReturn: any = [];

    this.dataSource.forEach(element => {
      var objectAux = {
        product_id: element.id,
        product_price: element.base_price,
        trial_price: element.trial_price,
        trial_end_cap: element.trial_end_cap
      }
      arrayToReturn.push(objectAux);
    });

    var body = {
      organization_id: id,
      status_ca: "active",
      charge_frequency: charge_frequency,
      currency_id: 1,
      trial_end: trial_end,
      products_array: arrayToReturn
    }

    this.mService.post_request('full-commercial-agreement/create', body)
    .subscribe((resp: any)=>{
      if(resp.status){
        this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
        this.router.navigate(['/dashboard/trade-agreements']);
      }
    })
  }

  getDataOrganization(){
    var id = this.organizationForm.get('organization_id').value;

    // reset fields
    this.organizationForm.get('organization_label').setValue('---');
    this.organizationForm.get('organization_phone').setValue('---');
    this.organizationForm.get('organization_name_contact').setValue('---');
    this.organizationForm.get('organization_city').setValue('---');
    this.organizationForm.get('organization_zone').setValue('---');
    this.organizationForm.get('organization_email').setValue('---');

    this.mService.get_request('full_organization', { id: id })
    .subscribe((resp: any)=>{
      if(resp.status){
        var organization = resp.items;

        this.organizationForm.get('organization_label').setValue(organization?.label_organization);
        this.organizationForm.get('organization_phone').setValue(organization?.cellphone_contact);
        this.organizationForm.get('organization_name_contact').setValue(organization?.first_name_contact + ' ' + organization?.last_name_contact || '---');
        if (organization?.branch_offices != null) {
          this.organizationForm.get('organization_city').setValue(organization?.branch_offices[0]?.city || '---');
          this.organizationForm.get('organization_zone').setValue(organization?.branch_offices[0]?.zone || '---');
        }
        this.organizationForm.get('organization_email').setValue(organization?.email);

      }else{
        if(resp.message){
          this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
          if(resp.message.includes('expirado')){
            this.uService.logOut$.next(true);
          }
        }
      }
    })
  }

  getOrganizationList(){
    this.mService.get_request('organizations/list')
    .subscribe((resp: any)=>{
      if(resp.status){
        this.organizations = resp.items;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    });
  }


  constructor(
    public dialog: MatDialog,
    private router: Router,
    private uService: UtilsService,
    private toast: ToastrService,
    private mService: MainService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalViewTradeAgreementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    if(data.id != undefined){
      this.organizationForm.get('organization_id').setValue(data.id_organization);
      this.organizationForm.get('charge_frequency').setValue(data.charge_frequency);
      this.organizationForm.get('trial_end').setValue(data.trial_end);
      this.getDataOrganization();
      this.dataSource = data.commercial_agreements_products;
      this.getOrganizationList();
    }

  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  dismiss(data?) {
    this.dialogRef.close( null );
  }
}

